import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTableModule } from '@angular/material/table';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatInputModule } from '@angular/material/input';


import { WebcrawlingRoutingModule } from './webcrawling-routing.module';
import { WebcrawlingChoiceComponent } from './webcrawling-choice/webcrawling-choice.component';
import { WebcrawlingResultComponent } from './webcrawling-result/webcrawling-result.component';
import { SupplierDetailComponent } from './supplier-detail/supplier-detail.component';

@NgModule({
  declarations: [
    WebcrawlingChoiceComponent,
    WebcrawlingResultComponent,
    SupplierDetailComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    WebcrawlingRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatTableModule,
    MatGridListModule,
    MatInputModule
  ]
})
export class WebcrawlingModule { }
